import React from "react";
import { Box, CircularProgress, Paper, Typography } from "@mui/material";
import AgentMarkdownMessage from "./AgentMarkdownMessage";
import {
  stripStructuredBlocksForDisplay,
  type AgentStructuredBlockPreset,
} from "../../utils/agentMessageDisplay";

export interface AgentChatMessageBubbleProps {
  role: "user" | "assistant";
  content: string;
  /** True while assistant message is streaming and content is still empty. */
  isStreaming?: boolean;
  structuredBlockPreset?: AgentStructuredBlockPreset;
  emptyAssistantFallback?: string;
}

const AgentChatMessageBubble: React.FC<AgentChatMessageBubbleProps> = ({
  role,
  content,
  isStreaming = false,
  structuredBlockPreset,
  emptyAssistantFallback,
}) => {
  const isUser = role === "user";

  return (
    <Paper
      elevation={0}
      sx={{
        p: 1.5,
        maxWidth: { xs: "90%", md: "min(720px, 85%)" },
        bgcolor: isUser ? "primary.main" : "action.hover",
        color: isUser ? "primary.contrastText" : "text.primary",
        border: isUser ? "none" : 1,
        borderColor: isUser ? undefined : "divider",
      }}
    >
      {isUser ? (
        <Typography variant="body2" component="div" sx={{ whiteSpace: "pre-wrap" }}>
          {content}
        </Typography>
      ) : isStreaming && !content.trim() ? (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <CircularProgress size={16} />
          <Typography variant="body2" color="text.secondary">
            Working…
          </Typography>
        </Box>
      ) : (
        <AgentMarkdownMessage
          content={
            stripStructuredBlocksForDisplay(content, structuredBlockPreset) ||
            emptyAssistantFallback ||
            ""
          }
        />
      )}
    </Paper>
  );
};

export default AgentChatMessageBubble;
